import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useContext } from 'react'; // import { Icon } from '../index'

import classnames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import { tuple } from '../_utils/type';
import { isArrayValueRepeat } from '../_utils/arrayUtil';
import Checkbox from './checkbox';
import devWarning from '../_utils/devwarning';
export var CheckboxTypes = tuple('default', 'square');
export var CheckboxSizes = tuple('large', 'middle', 'small');
export var GroupContext = /*#__PURE__*/React.createContext(null);
var CheckboxGroup = /*#__PURE__*/React.forwardRef(function (props, ref) {
  // const CheckboxGroup = (props: CheckboxGroupProps): FunctionComponentElement<CheckboxGroupProps> => {
  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps;

  var CheckboxProps = getCompProps('Checkbox', userDefaultProps, props); // 按钮属性需要合并一遍用户定义的默认属性

  var checkboxType = CheckboxProps.checkboxType,
      className = CheckboxProps.className,
      style = CheckboxProps.style,
      customPrefixcls = CheckboxProps.prefixCls,
      options = CheckboxProps.options,
      size = CheckboxProps.size,
      onChange = CheckboxProps.onChange,
      disabled = CheckboxProps.disabled,
      children = CheckboxProps.children,
      defaultValue = CheckboxProps.defaultValue,
      value = CheckboxProps.value,
      name = CheckboxProps.name;
  var initData = value || (Array.isArray(defaultValue) ? defaultValue : typeof defaultValue !== 'undefined' ? [defaultValue] : []);

  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      groupValue = _React$useState2[0],
      setGroupValue = _React$useState2[1];

  var innerValue = React.useRef(initData);
  React.useEffect(function () {
    innerValue.current = value || (Array.isArray(defaultValue) ? defaultValue : typeof defaultValue !== 'undefined' ? [defaultValue] : []);
    setGroupValue(innerValue.current);
  }, [value, defaultValue]);
  var isControlled = typeof value !== 'undefined';
  var checkboxGroupPrefixCls = getPrefixCls(prefixCls, 'checkbox-group', customPrefixcls); // 按钮样式前缀

  devWarning(isArrayValueRepeat(groupValue), 'checkboxGroup', "variable value's value should be unique ");

  var getReduceItem = function getReduceItem(targetValue) {
    var _context;

    return _filterInstanceProperty(_context = innerValue.current).call(_context, function (d) {
      return d !== targetValue;
    });
  };

  var getAddItem = function getAddItem(targetValue) {
    var _context2;

    return innerValue.current.indexOf(targetValue) > -1 ? innerValue.current : _concatInstanceProperty(_context2 = innerValue.current).call(_context2, targetValue);
  };

  var onCheckboxChange = function onCheckboxChange(checkedValue, isChecked, e) {
    var newVal = [];

    if (isChecked) {
      newVal = getAddItem(checkedValue);
    } else {
      newVal = getReduceItem(checkedValue);
    }

    if (!isControlled) {
      innerValue.current = newVal;
    }

    onChange && onChange(e, newVal);
  };

  var context = {
    groupValue: groupValue,
    disabled: disabled,
    name: name,
    isControlled: isControlled,
    checkboxType: checkboxType,
    onCheckboxGroupChange: function onCheckboxGroupChange(checkedValue, isChecked, e) {
      onCheckboxChange(checkedValue, isChecked, e);
    }
  };

  var renderByOptions = function renderByOptions() {
    return _mapInstanceProperty(options).call(options, function (option, index) {
      return /*#__PURE__*/React.createElement(Checkbox, {
        size: size,
        disabled: option.disabled,
        key: index,
        name: name,
        defaultChecked: option.defaultValue,
        checked: option.checked,
        checkboxType: checkboxType,
        value: (option === null || option === void 0 ? void 0 : option.value) || option,
        onChange: option.onChange
      }, option.label || option);
    });
  };

  return /*#__PURE__*/React.createElement("ul", {
    className: classnames(checkboxGroupPrefixCls, className),
    style: style,
    ref: ref
  }, /*#__PURE__*/React.createElement(GroupContext.Provider, {
    value: context
  }, options && options.length > 0 ? renderByOptions() : children));
});
export default /*#__PURE__*/React.memo(CheckboxGroup);